@if (isGeneralHelpRoute() && !config()?.isSidebar) {
  <plyca-ui-button-generic
    id="general-help-scroll-top-btn"
    [config]="{ buttonClass: 'general-help__scroll-top-btn', type: 'button' }"
    [title]="'General.scrollTop' | translate"
    (clickEvent)="resetScroll()"
    [ariaLabel]="'General.scrollTop' | translate"
  >
    <i class="fa fa-angle-double-up" aria-hidden="true"></i>
  </plyca-ui-button-generic>
}
@if (isLoadedSig()) {
  <div class="wrapper wrapper-content" [class.p-0]="effectiveMode() === selectHelpMode.ACCORDION">
    <div [class.container-fluid]="effectiveMode() === selectHelpMode.ACCORDION">
      @if (helperOptions?.length > 0) {
        <div class="row mt-3">
          <div class="col-12 pl-0 pr-0">
            <p-accordion>
              <div class="general-help__container-help-panel" [class.general-help__container-help-panel-support]="isGeneralHelpRoute()">
                <p-accordionTab>
                  <p-header> <i aria-hidden="true" class="fas fa-bars fa-lg mr-2"></i>{{ 'General.help.support' | translate }} </p-header>
                  @for (option of helperOptions; track option.name) {
                    <ul class="general-help__container-help-panel-list--ul">
                      <li class="general-help__container-help-panel-list--li">
                        <plyca-ui-button-generic
                          [config]="{ buttonClass: 'btn btn-sm btn-transparent general-help__container-help-panel-list--button m-0', type: 'button' }"
                          (clickEvent)="openUrl(option.url)"
                        >
                          <p class="db select-all gray5 hover-gray7 text text-left mb-0" [innerHTML]="option.name | translate"></p>
                        </plyca-ui-button-generic>
                      </li>
                    </ul>
                  }
                </p-accordionTab>
              </div>
            </p-accordion>
          </div>
        </div>
      }
      @if (helpContent) {
        <div class="row">
          <div
            class="pl-0 pr-0 sticky-top help-index"
            [class.col-3]="(isDesktop() && isGeneralHelpRoute()) || !isDesktop()"
            [class.col-12]="effectiveMode() === selectHelpMode.ACCORDION"
            [class.border-0]="effectiveMode() === selectHelpMode.ACCORDION"
          >
            <div class="sticky-top">
              @if (effectiveMode() === selectHelpMode.ACCORDION) {
                <p-accordion [(activeIndex)]="accordionIndex">
                  <div class="general-help__container-help-panel">
                    <p-accordionTab>
                      <p-header> <i aria-hidden="true" class="fas fa-bars fa-lg mr-2"></i> {{ 'General.help.sections' | translate }} </p-header>
                      <p-tree [value]="helpContent" styleClass="pl-0" selectionMode="single" [metaKeySelection]="true" [(selection)]="selectedHelp" (onNodeSelect)="onNodeSelect($event)"> </p-tree>
                    </p-accordionTab>
                  </div>
                </p-accordion>
              } @else {
                <p-tree [value]="helpContent" styleClass="pl-0" selectionMode="single" [metaKeySelection]="true" [(selection)]="selectedHelp" (onNodeSelect)="onNodeSelect($event)"> </p-tree>
              }
            </div>
          </div>
          @if (effectiveMode() !== selectHelpMode.ACCORDION) {
            <div class="col-9">
              <ng-container [ngTemplateOutlet]="contentSelectedHelp" />
            </div>
          }
        </div>
      } @else {
        <p>{{ 'Help.noHelp' | translate }}</p>
      }
      @if (effectiveMode() === selectHelpMode.ACCORDION) {
        <div class="row">
          <ng-container [ngTemplateOutlet]="contentSelectedHelp" />
        </div>
      }
    </div>
    <ng-template #contentSelectedHelp>
      <div class="m-t-lg" id="print-section" [class.col-9]="!isDesktop()" [class.col-12]="isDesktop()">
        @if (selectedHelp) {
          <div class="col-12 p-0 text-right mb-3">
            <plyca-ui-button-generic [config]="{ buttonClass: 'btn btn-sm btn-outline-primary print-btn', type: 'button' }" (clickEvent)="print()">
              <span> <i class="fa fa-print" aria-hidden="true"></i> {{ 'General.printsection' | translate }}</span>
            </plyca-ui-button-generic>
          </div>
        }
        <h1 *ngIf="selectedHelp">{{ selectedHelp.label }}</h1>
        <div class="col-12 pb-4" *ngIf="isIndexNeeded(selectedHelp)">
          <ng-container *ngIf="selectedHelp; else noSelection">
            <ng-container *ngIf="isFolder(selectedHelp)">
              <ng-container [ngTemplateOutlet]="indexEntry" [ngTemplateOutletContext]="{ folder: selectedHelp, folderid: '', level: 2 }"></ng-container>
            </ng-container>
            <ng-container *ngIf="!isFolder(selectedHelp)">
              <div *ngFor="let element of selectedHelp.data.content; let grpid = index">
                <a *ngIf="!isFolder(selectedHelp)" plycaAnchorLink style="font-weight: 200" (click)="onGoToElement(element.identifier)">{{ grpid + 1 }}. {{ element.name }}</a>
              </div>
            </ng-container>
          </ng-container>
        </div>
        <div class="col-12">
          <ng-container *ngIf="selectedHelp; else noSelection">
            <ng-container [ngTemplateOutlet]="helpEntry" [ngTemplateOutletContext]="{ folder: selectedHelp, folderid: '', level: 2 }"></ng-container>
          </ng-container>
        </div>
        <ng-template #noSelection>
          <div class="general-help__container-help--not-help">
            <i class="fa fa-info general-help__container-help--not-help-icon"></i>
            <p class="general-help__container-help--not-help-text" [innerHTML]="'Help.noElements' | translate"></p>
          </div>
        </ng-template>
      </div>
    </ng-template>
    <ng-template #indexEntry let-folder="folder" let-folderid="folderid" let-level="level">
      <div *ngFor="let element of folder.children; let grpid = index" [ngClass]="'ml-' + (level - 1) * 2">
        <h2 *ngIf="level === 2" class="mb-2 mt-3" style="font-weight: 200">
          <a plycaAnchorLink style="font-weight: 200" (click)="onGoToElement('IDX_' + (folderid ? folderid : '0') + '_' + grpid)"
            >{{ (folderid ? folderid + '.' : '') + (grpid + 1) }}. {{ element.label }}
          </a>
        </h2>
        <h3 *ngIf="level === 3" class="mb-2 mt-3" style="font-weight: 200">
          <a plycaAnchorLink style="font-weight: 200" (click)="onGoToElement('IDX_' + (folderid ? folderid : '0') + '_' + grpid)"
            >{{ (folderid ? folderid + '.' : '') + (grpid + 1) }}. {{ element.label }}
          </a>
        </h3>
        <h4 *ngIf="level === 4" class="mb-2 mt-3" style="font-weight: 200">
          <a plycaAnchorLink style="font-weight: 200" (click)="onGoToElement('IDX_' + (folderid ? folderid : '0') + '_' + grpid)"
            >{{ (folderid ? folderid + '.' : '') + (grpid + 1) }}. {{ element.label }}
          </a>
        </h4>
        <ng-container *ngIf="hasContent(element) && !isFolder(element)">
          <div *ngFor="let grp of element.data.content; let elemId = index" class="pl-4">
            <a plycaAnchorLink style="font-weight: 200" (click)="onGoToElement(grp.identifier)">{{ (folderid ? folderid + '.' : '') + (grpid + 1) }}.{{ elemId + 1 }} {{ grp.name }}</a>
          </div>
        </ng-container>
        <ng-container *ngIf="isFolder(element)">
          <ng-container [ngTemplateOutlet]="indexEntry" [ngTemplateOutletContext]="{ folder: element, folderid: (folderid ? folderid + '.' : '') + (grpid + 1), level: level + 1 }"></ng-container>
        </ng-container>
      </div>
    </ng-template>
    <ng-template #helpEntry let-folder="folder" let-folderid="folderid" let-level="level">
      <div *ngFor="let element of folder.children; let grpid = index" [ngClass]="'ml-' + (level - 1) * 2">
        <h2 *ngIf="level === 2" class="mb-4 mt-3" style="font-weight: 100" id="{{ 'IDX_' + (folderid ? folderid : '0') + '_' + grpid }}">
          {{ (folderid ? folderid + '.' : '') + (grpid + 1) }}. {{ element.label }}
        </h2>
        <h3 *ngIf="level === 3" class="mb-4 mt-3" style="font-weight: 100" id="{{ 'IDX_' + (folderid ? folderid : '0') + '_' + grpid }}">
          {{ (folderid ? folderid + '.' : '') + (grpid + 1) }}. {{ element.label }}
        </h3>
        <h4 *ngIf="level >= 4" class="mb-4 mt-3" style="font-weight: 100" id="{{ 'IDX_' + (folderid ? folderid : '0') + '_' + grpid }}">
          {{ (folderid ? folderid + '.' : '') + (grpid + 1) }}. {{ element.label }}
        </h4>
        <ng-container *ngIf="hasContent(element) && !isFolder(element)">
          <div *ngFor="let entry of element.data.content; let elemId = index" [ngClass]="'ml-' + (level - 1) * 2">
            <plyca-help-element [helpElement]="entry" [showTitle]="true" [indexLevel]="level" [indexStr]="'' + (folderid ? folderid + '.' : '') + (grpid + 1) + '.' + (elemId + 1)">
            </plyca-help-element>
          </div>
        </ng-container>
        <ng-container *ngIf="isFolder(element)">
          <ng-container [ngTemplateOutlet]="helpEntry" [ngTemplateOutletContext]="{ folder: element, folderid: (folderid ? folderid + '.' : '') + (grpid + 1), level: level + 1 }"></ng-container>
        </ng-container>
      </div>
      <ng-container *ngIf="!isFolder(folder)">
        <div *ngFor="let entry of folder.data.content; let elemId = index" [ngClass]="'ml-' + (level - 1) * 2">
          <plyca-help-element [helpElement]="entry" [showTitle]="true" [indexLevel]="level" [indexStr]="'' + (folderid ? folderid + '.' : '') + (elemId + 1)"> </plyca-help-element>
        </div>
      </ng-container>
    </ng-template>
  </div>
}
